// Types
import { RootState } from 'types/RootState.types';

// Config
import { DISABLED_FEATURE } from '@constants/featureConstants';
import { isFeatureDisabled } from '@redux/reducers/config/configReducer';

export const shouldShowApplePayFeature = (state: RootState): boolean => {
  const isDisabled = isFeatureDisabled(state, DISABLED_FEATURE.APPLE_PAY);

  return !isDisabled;
};
